import { DefaultTheme } from 'styled-components';

export const darkTheme: DefaultTheme = {
  palette: {
    brand: {
      main: '#FFD966'
    },
    textAndLabels: {
      main: '#FCFCFC',
      secondary: '#D3D3D3',
      tertiary: '#A6A6A6',
      quaternary: '#D4A300',
      approved: '#3DB460',
      rejected: '#FF586D',
      pending: '#C69C00',
      expired: '#FCFCFC',
      premium: 'linear-gradient(180deg, #2B2B2B 0%, #777 100%);',
      blue: '#7CC4F8',
      dark: '#2F2F2F',
      primary: '#212C3A',
      bump: 'linear-gradient(180deg, #8EA297 0%, #6C748E 44.57%, #3D464B 106.05%)'
    },
    bg: {
      resumeCard: '#282828',
      main: '#282828',
      secondary: '#343434',
      tertiary: '#FFEEA5',
      card: '#383838',
      cardHover: '#454545',
      approved: '#C9F4D6',
      rejected: '#FFDCE0',
      pending: '#FFEEA5',
      expired: '#696969',
      user: '#FFEEA5',
      section: '#37474F',
      premium: '#C8EF01'
    },
    system: {
      deepBlue: '#5993FF',
      blue: '#4D6DFF',
      contactButton: '#798EAE',
      lightBlue: '#E3EEFF',
      lightBlueHover: '#8BA6D1',
      green: '#4EBE6F',
      red: '#FF697C',
      redHover: '#3B2729',
      yellow: '#FFB900',
      white: '#FDFDFD',
      black: '#1A1A1A',
      brand: '#FFEEA5'
    },
    border: {
      main: '#696969',
      primary: '#EAEBF2',
      secondary: '#525252',
      tertiary: '#4A4A4A',
      dark: '#2F2F2F'
    },
    shadow: {
      main: '#696969',
      accent: '#15AD36'
    }
  }
};
